<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-医生-修改
    -->
    <el-dialog
    title="修改医生"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <el-form-item label="绑定的用户" >
        <el-button @click="openGetuser('doctor')" icon="el-icon-plus">选择医生（用户）</el-button>
        <div>  昵称：{{ user.nickName?user.nickName:"还未选择" }}</div>

      </el-form-item>

      <!-- <el-form-item label="所属医院" >
        <el-select id="searchType" v-model="form.hospital_id" class="searchType">
          <el-option v-for="(item,index) in hospital" :key="index" :label="item.name" :value="item.hospital_id"></el-option>

        </el-select>
      </el-form-item> -->


      <el-form-item label="预约设置">
  <el-button size="small" type="primary" @click="addSetting">新增预约设置</el-button>

  <!-- 原有的预约设置表格 -->
        <el-table :data="form.setting"  border size="mini" style="width: 100%;margin-top: 20px;">

          <el-table-column prop="name" label="医院"   width="200" >
            <template v-slot="scope">
              <div class="d-s-c">
                <el-select id="searchType" v-model="scope.row.hospital_id" class="searchType">
                  <el-option v-for="(item,index) in hospital"
                             :key="index"
                             :label="item.name"
                             :value="item.hospital_id"></el-option>

                </el-select>
              </div>
            </template>
          </el-table-column>


          <el-table-column prop="name" label="周几"   width="200" >
            <template v-slot="scope">
              <div class="d-s-c">
                <el-select id="searchType" v-model="scope.row.dates" class="searchType">
                  <el-option  label="周一" value="1"></el-option>
                  <el-option  label="周二" value="2"></el-option>
                  <el-option  label="周三" value="3"></el-option>
                  <el-option  label="周四" value="4"></el-option>
                  <el-option  label="周五" value="5"></el-option>
                  <el-option  label="周六" value="6"></el-option>
                  <el-option  label="周日" value="7"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="选择开始时间"   width="200" >
            <template v-slot="scope">
              <div class="d-s-c">
                <el-time-picker
                  v-model="scope.row.times_one"
                  start-placeholder="时间"
                  placeholder="选择开始时间"
                  format="HH:mm"
                  value-format="HH:mm"
                >
                </el-time-picker>
              </div>
            </template>
          </el-table-column>


          <el-table-column prop="name" label="选择结束时间"   width="200" >
            <template v-slot="scope">
              <div class="d-s-c">
                <el-time-picker
                  v-model="scope.row.times_two"
                  start-placeholder="时间"
                  placeholder="选择结束时间"
                  format="HH:mm"
                  value-format="HH:mm"
                >
                </el-time-picker>
              </div>
            </template>
          </el-table-column>



          <el-table-column prop="name" label="操作"  width="100">
            <template v-slot="scope">
              <div style="color: blue;" @click="delSetting(scope.$index)">删除</div>

            </template>
          </el-table-column>
        </el-table>

          <!-- 时间段设置（单独放在预约设置下面） -->
  <div class="time-slot-settings" style="margin-top: 20px; border: 1px solid #ebeef5; padding: 15px; border-radius: 4px;">
    <div style="margin-bottom: 10px; font-weight: bold;">时间段设置</div>

    <el-table :data="form.time_slots" border size="mini" style="width: 100%;">
      <el-table-column label="时间段" width="200">
        <template v-slot="scope">
          <div style="display: flex; align-items: center;">
            <el-time-picker v-model="scope.row.start_time" format="HH:mm" value-format="HH:mm"
                           placeholder="开始时间" style="width: 90px;"></el-time-picker>
            <span style="margin: 0 5px;">至</span>
            <el-time-picker v-model="scope.row.end_time" format="HH:mm" value-format="HH:mm"
                           placeholder="结束时间" style="width: 90px;"></el-time-picker>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="可预约人数" width="150">
        <template v-slot="scope">
          <el-input-number v-model="scope.row.max_patients" :min="1" :max="100"
                          size="mini" style="width: 120px;"></el-input-number>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="80">
        <template v-slot="scope">
          <el-button type="text" @click="delTimeSlot(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-button size="small" type="primary" @click="addTimeSlot" style="margin-top: 10px;">
      添加时间段
    </el-button>
  </div>
</el-form-item>



      <el-form-item label="所属科室" >
        <el-select id="searchType" v-model="form.hdepart_id" class="searchType">
          <el-option v-for="(item,index) in hdepart" :key="index" :label="item.name" :value="item.hdepart_id"></el-option>

        </el-select>
      </el-form-item>



      <el-form-item label="医生名称" prop="name"><el-input v-model="form.name" placeholder="请输入医生名称" class="max-w460"></el-input></el-form-item>




      <el-form-item label="照片：" prop="model.cover_image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.cover_image">
          <transition-group>
            <div v-for="(item, index) in form.cover_image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


    <el-form-item label="擅长" prop="good">
      <el-input v-model="form.good" type="textarea" placeholder="请输入医生擅长" class="max-w460"></el-input></el-form-item>

      <el-form-item label="从业年限" prop="epoae">
      <el-input v-model="form.epoae" type="textarea" placeholder="请输入从业年限" class="max-w460"></el-input></el-form-item>


      <el-form-item label="星级" prop="epoae">
      <el-input v-model="form.star" type="number" placeholder="请输入星级(0~5)" class="max-w460"></el-input></el-form-item>


      <el-form-item label="疗效" prop="epoae">
      <el-input v-model="form.lx" type="number" placeholder="请输入疗效(0~5)" class="max-w460"></el-input></el-form-item>


<!--

      <el-form-item label="职称" >
        <el-select id="searchType" v-model="form.director" class="searchType">
          <el-option v-for="(item,index) in director" :key="index" :label="item.name" :value="item.code"></el-option>

        </el-select>
      </el-form-item>

  !-->






      <el-form-item label="区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>

      </el-form-item>


            <el-form-item label="详细地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
            </el-form-item>


      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    <GetInsUser :is_open="open_cm" :code="code" :multi="multi"   @close="closeCm"></GetInsUser>

  </div>
</el-dialog>

</template>

<script>
import DoctorApi from '@/api/doctor.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import select_region from '@/utils/select.district.js';
import GetInsUser from '@/components/user/getInsUser.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter,
     GetInsUser
  },
  data() {
    return {
        /*是否上传图片*/
        isupload: false,
        isImg: false,
        /*富文本配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        cover_image:[],
        sort:50,
        intro:"",
        bannar:[],
        label:[],
        province_id:0,
        city_id:0,
        region_id:0,
        address:"",
        director:"",
        good:"",
        epoae:"",
        hospital_id:0,
        hdepart_id:0,
        star:5,
        lx:5,
        user_id:0,
        time_slots: [], // 时间段设置
        setting:[],
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入医生名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         label:[],
      /*省市区*/
      areaList: select_region,
      director:[],
      hospital:[],
      hdepart:[],
      open_cm:false,
        code:"",
        multi:false,
        user:{

        }
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getSetting();
  },
  props: ["open_add","doctor_id"],
  methods: {
    delSetting(index){
        this.form.setting.splice(index,1)
    },

     // 添加时间段
  addTimeSlot() {
    this.form.time_slots.push({
      start_time: '09:00',
      end_time: '12:00',
      max_patients: 1
    });
  },

  // 删除时间段
  delTimeSlot(index) {
    this.form.time_slots.splice(index, 1);
  },

      addSetting(){
  this.form.setting.push({
    dates: '',
    times_one: "09:00",
    times_two: "12:00",
    hospital_id: 0,
    duration: 30,  // 默认30分钟一个时段
    max_patients: 1 // 默认每个时段1人
  });
},


        /*打开获取用户*/
        openGetuser(code) {
      this.open_cm = true;
      this.code = code;
    },
    closeCm(e){
      var self = this;
      self.open_cm=false;
      if(e.params && e.params.user_id){

        self.form.user_id = e.params.user_id;
        self.user.mobile = e.params.mobile;
        self.user.nickName = e.params.nickName;

      }


    },
    getSetting(){
      var self = this;
      self.getSetting_common({
        "item":'hospital',
        'condi':['hospital','hdepart'],

      },function(data){
          console.log('data',data)
          self.label = data.vars.values.label
          self.director = data.vars.values.director
          self.hospital = data.obj.hospital
          self.hdepart = data.obj.hdepart
      })

    },
    delLabel(index){
        this.form.label.splice(index,1)
    },

      labelChange(e){
        var ind = 0;
        for(var i=0;i<this.form.label.length;i++){
          if(this.form.label[i].code == e.code){
            ind++;
          }
        }
        if(ind<=0){
          this.form.label.push(e);
        }

      },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;

      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
   getDetail() {
  let self = this;
  // 取到路由带过来的参数
  DoctorApi.detail({doctor_id: self.doctor_id},true).then(res => {
      self.form = res.data;
      console.log('self.form',self.form);
      self.isImg = true
      self.loading = false;
      self.user =  self.form.user

      if(!self.form.bannar){
        self.form.bannar = [];
      }
      if(!self.form.cover_image){
        self.form.cover_image = [];
      }
      if(!self.form.setting){
        self.form.setting = [];
      }
      // 添加这行初始化 time_slots
      if(!self.form.time_slots) {
        self.form.time_slots = [];
      }

    })
    .catch(error => {});
},
  onSubmit() {
  let self = this;
  let form = {
    ...self.form, // 展开原有表单数据
    doctor_id: self.doctor_id,
    // 确保 time_slots 是数组格式
    time_slots: Array.isArray(self.form.time_slots) ? JSON.stringify(self.form.time_slots) : '[]'
  };

  self.$refs.form.validate(valid => {
    if (valid) {
      self.loading = true;
      DoctorApi.edit(form, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '保存成功',
            type: 'success'
          });
          self.dialogFormVisible("error")
        })
        .catch(error => {
          self.loading = false;
          self.$message.error(error.message || '保存失败');
        });
    }
  });
},

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },


  /*上传商品图片*/
  returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = e;
        this.$set(this.form, "cover_image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.cover_image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }

    },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/hospital/doctor/index/part/edit.vue